import clsx from 'clsx';
import { createElement, ElementType } from 'react';

import useLabels from '~hooks/useLabels';
import styles from '~modules/downloads/Downloads.module.css';

export function EmptyDownload({ as: Component = 'div' }: { as?: ElementType }) {
  const { msgModuleFileEmpty } = useLabels(['msgModuleFileEmpty']);

  return createElement(
    Component,
    { className: clsx(styles.listItem, 'downloads-listitem') },
    <div className={clsx(styles.listItemContent, 'downloads-listitem--content')}>
      <div className={clsx(styles.name, 'downloads-listitem--name')}>{msgModuleFileEmpty}</div>
    </div>,
  );
}
